module.exports = __webpack_public_path__ + "assets/0fe11759de595a733200592c5250004a.png";